<template>
  <div>
    <article-view v-if="article && article.id" :data="article"></article-view>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ArticleView from '~/components/article/ArticleView'

export default {
  name: 'ViewArticle',
  components: {
    ArticleView,
  },
  beforeRouteLeave(to, from, next) {
    this.clearState({
      scope: 'articles',
      val: {},
    })
    next()
  },
  layout: 'client',
  fetch() {
    return this.editResource({
      scope: 'articles',
      key: 'slug',
      slug: this.$route.params.slug,
    })
  },
  computed: {
    ...mapState('articles', ['article']),
  },
  methods: {
    ...mapActions('resources', ['editResource', 'clearState']),
  },
}
</script>
